import {
    createHandlerChainRunner,
    createHandlerChainRunnerOptionalParameter,
    Handler,
} from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tCentro/Store/CustomHandlerCreator";

interface Parameter {
    isOrderNotesDisabledValue: boolean;
}

type HandlerType = CustomHandler<Parameter>;

export const CenSpcOrderNotesDisabled: HandlerType = props => {
    props.dispatch({
        type: "Pages/OnePageCheckout/CenSpcIsOrderNotesDisabled",
        isOrderNotesDisabledValue: props.parameter.isOrderNotesDisabledValue,
    });
};

export const chain = [CenSpcOrderNotesDisabled];

const cenSpcOrderNotesDisabled = createHandlerChainRunner(chain, "CenSpcOrderNotesDisabled");
export default cenSpcOrderNotesDisabled;
